import { render, staticRenderFns } from "./VQSign.vue?vue&type=template&id=80f5fa30&"
import script from "./VQSign.vue?vue&type=script&lang=js&"
export * from "./VQSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports